import { render, staticRenderFns } from "./dispatcher-dialog-create.vue?vue&type=template&id=bb120d6a"
import script from "./dispatcher-dialog-create.vue?vue&type=script&lang=js"
export * from "./dispatcher-dialog-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports